import { render } from "./Edit.vue?vue&type=template&id=0fc1a980&bindings={\"errors\":\"props\",\"classroom\":\"props\",\"teachers\":\"props\",\"assigned_students\":\"props\",\"unassigned_students\":\"props\",\"form\":\"data\",\"update\":\"options\"}"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0fc1a980"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fc1a980')) {
    api.reload('0fc1a980', script)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=0fc1a980&bindings={\"errors\":\"props\",\"classroom\":\"props\",\"teachers\":\"props\",\"assigned_students\":\"props\",\"unassigned_students\":\"props\",\"form\":\"data\",\"update\":\"options\"}", () => {
    api.rerender('0fc1a980', render)
  })

}

script.__file = "resources/js/Pages/Classrooms/Edit.vue"

export default script